<template>
  <section :class="['subscription-bar', backgroundClass]">
    <div class="subscription-bar-wrapper md:container mb-[40px] md:mb-[80px] px-5 lg:px-0">
      <!-- Latest News -->
      <LatestNews />
      <!-- ./Latest News -->

      <div class="flex flex-col md:w-2/5">
        <!-- Email Subscription -->
        <EmailSubscription class="mb-[40px] md:mb-[80px]" />
        <!-- ./Email Subscription -->

        <!-- Social Media -->
        <SocialMedia />
        <!-- ./Social Media -->
      </div>
    </div>
  </section>
</template>
<script>
import LatestNews from '~/components/blog/subscriptionBar/LatestNews.vue';
import EmailSubscription from '~/components/blog/subscriptionBar/EmailSubscription.vue';
import SocialMedia from '~/components/blog/subscriptionBar/SocialMedia.vue';

export default {
  name: 'Subscription',
  components: {
    EmailSubscription,
    LatestNews,
    SocialMedia,
  },
  props: {
    backgroundClass: {
      type: String,
      default: 'bg-[#f4f7fe]',
    },
  },
};
</script>
<style lang="scss" scoped>
.subscription-bar {
  @apply py-[20px] md:pt-[80px] md:pb-[40px];

  &-wrapper {
    @apply md:container px-5 lg:px-0 md:px-0 flex flex-col sm:flex-row gap-[47px] md:gap-[165px] justify-between;
  }
}
</style>
